import { NestedCheckboxGroupOptionType } from '../../common'

export const restructureDataSets: (
    dataSets: NestedCheckboxGroupOptionType[]
) => NestedCheckboxGroupOptionType[] = (dataSets) => {
    const newDataSets: NestedCheckboxGroupOptionType[] = []

    const shouldBeTotalCostChild = (option: NestedCheckboxGroupOptionType) => {
        return [
            'cost_commodity',
            'cost_transport',
            'cost_taxes',
            'cost_other',
        ].includes(option.value)
    }

    dataSets.forEach((dataSet) => {
        const newDataSet: NestedCheckboxGroupOptionType = {
            value: dataSet.value,
            label: dataSet.label,
        }

        if (
            dataSet.value === 'cost_commodity' &&
            dataSet.children?.filter(
                (d) => d.value === 'cost_commodity_totalCommodityCost'
            ).length
        ) {
            newDataSet.value = 'cost_commodity_totalCommodityCost'

            const children = dataSet.children.filter(
                (option) => option.value !== 'cost_commodity_totalCommodityCost'
            )

            newDataSet.children = children

            newDataSets.push(newDataSet)
            return
        }

        if (
            dataSet.value === 'cost_transport' &&
            dataSet.children?.filter(
                (d) => d.value === 'cost_transport_totalTransportCost'
            ).length
        ) {
            newDataSet.value = 'cost_transport_totalTransportCost'

            const children = dataSet.children.filter(
                (option) => option.value !== 'cost_transport_totalTransportCost'
            )

            newDataSet.children = children

            newDataSets.push(newDataSet)
            return
        }

        if (dataSet.value === 'cost' && dataSet.children) {
            const totalCostChildren = dataSet.children.filter(
                shouldBeTotalCostChild
            )

            const remainingChildren = dataSet.children.filter(
                (option) =>
                    option.value !== 'cost_totalInvoiced' &&
                    !shouldBeTotalCostChild(option)
            )

            const totalCostDataSet = dataSet.children.find(
                (option) => option.value === 'cost_totalInvoiced'
            )

            if (totalCostDataSet) {
                newDataSet.children = [
                    {
                        value: totalCostDataSet.value,
                        label: totalCostDataSet.label,
                        children: restructureDataSets(totalCostChildren),
                    },
                    ...remainingChildren,
                ]

                newDataSets.push(newDataSet)
                return
            }
        }

        if (dataSet.children) {
            newDataSet.children = restructureDataSets(dataSet.children)
        }

        newDataSets.push(newDataSet)
    })

    return newDataSets
}
